import {ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot} from "@angular/router";
import {EMPTY, Observable, of} from "rxjs";
import {Competitor} from "@model";
import {CompetitorService} from "@services";
import {inject} from "@angular/core";
import {LANDING_ROUTE, ORGANISER_DASHBOARD} from "../app-routing.module";
import {mergeMap, take} from "rxjs/operators";

export const CompetitorResolver: ResolveFn<Observable<Competitor | undefined> | Competitor | undefined> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  router: Router = inject(Router),
  competitorService: CompetitorService = inject(CompetitorService)
): Observable<Competitor | undefined> | Competitor | undefined => {
  const raceId: number = +route.queryParams['raceId'];
  if (route.queryParams['competitorId']) {
    return competitorService.fetchCompetitorById(+route.queryParams['competitorId']).pipe(
      take(1),
      mergeMap((res: Competitor | undefined) => {
        if (res) {
          if (raceId && res.raceId && +raceId !== res.raceId) {
            router.navigate([ORGANISER_DASHBOARD]);
            return EMPTY;
          }
          return of(res);
        } else {
          router.navigate([ORGANISER_DASHBOARD]);
          return EMPTY;
        }
      })
    );
  } else {
    router.navigate([LANDING_ROUTE]);
    return EMPTY;
  }
};
